
import {
  POST,
  GET,
} from '@/axios/axios'

export const services = {
  insertSelective: (param) => {   // 新增或修改列表样式
    return POST('/backend/userListStyle/insertSelective', param)
  },
  queryByPlatType: (param) => {   // 获取列表样式-列表
    return GET('/backend/userListStyle/queryByPlatType', param)
  },
  queryByPageUrl: (param) => {   // 获取列表样式-单个样式
    return GET('/backend/userListStyle/queryByPageUrl', param)
  },
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/tableSetting.js